/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Image, Link, UpdateNote, Mdx } from '@ta-interaktiv/contentbricks'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { MDXProvider } from '@mdx-js/react'
import { AllCountriesChart } from 'components/compareChart'

// TODO Set the correct article ID here
const ARTICLE_ID = '594923417757'

export function AppComponent() {
  return (
    <MDXProvider
      components={{
        table: props => (
          <table
            className='ui small compact unstackable table'
            style={{ margin: '2rem 0' }}
            {...props}
          />
        ),
        tr: props => <tr className='title six wide top aligned' {...props} />,
        td: props => <td style={{ paddingRight: 10 }} {...props} />,
        th: props => (
          <th className='top aligned' style={{ width: '33%' }} {...props} />
        ),
        a: Link
      }}
    >
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical very fitted segment'>
          <div className='ui container'>
            <Mdx
              className='ui header'
              file={require('text/bGwCb67YRyKp.mdx')}
            />
          </div>
        </header>

        <div className='ui vertical fitted segment intro'>
          <table className='ui small very compact collapsing unstackable table sweden'>
            <thead>
              <tr>
                <th colSpan='3'>
                  Schweden <div className='square' />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className='top aligned bold'>
                <td>Fläche</td>
                <td>447'435 km²</td>
              </tr>
              <tr className='top aligned'>
                <td>Einwohner</td>
                <td>
                  10,33 Mio. <span className='year'>(2019)</span>
                </td>
              </tr>
              <tr className='top aligned bold'>
                <td>Altersmedian</td>
                <td>
                  41,1 Jahre <span className='year'>(2020)</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table className='ui small very compact collapsing unstackable table switzerland'>
            <thead>
              <tr>
                <th colSpan='3'>
                  Schweiz <div className='square' />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className='top aligned bold'>
                <td>Fläche</td>
                <td>41'285 km²</td>
              </tr>
              <tr className='top aligned'>
                <td>Einwohner</td>
                <td>
                  8,60 Mio. <span className='year'>(2019)</span>
                </td>
              </tr>
              <tr className='top aligned bold'>
                <td>Altersmedian</td>
                <td>
                  43,1 Jahre <span className='year'>(2020)</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* TODO And probably remove the following segment and replace it with
       your own content */}
        <div className='ui vertical segment' style={{ paddingBottom: 0 }}>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>Andreas Moor, Patrick Vögeli</div>
              <div className='ta updated'>Aktualisiert am 24. Mai 2020</div>
            </div>
          </div>
          <div className='ui vertical very fitted segment'>
            <div className='ui text container'>
              {
                // Einleitung
              }
              <Mdx
                className='ta text'
                file={require('text/n96cAa_zD5hc.mdx')}
              />
            </div>
          </div>
          <div className='ui vertical very fitted segment section'>
            <div className='ui text container'>
              {
                // Massnahmen
              }
              <Mdx
                className='ta text'
                file={require('text/HIBPYn-VipUz.mdx')}
              />
              <Mdx
                className='ta text'
                file={require('text/wBPH6bk-eIae.mdx')}
              />
              <div style={{ margin: '2rem 0' }}>
                <div className='titleBox'>
                  <h4 className='ui infographic header'>
                    Die Schweiz erlässt Vorschriften, Schweden macht
                    Empfehlungen
                  </h4>
                  <span className='cases'>
                    Strenge der staatlichen Covid-Massnahmen gemäss «Oxford
                    Government Response Stringency Index», basierend auf 17
                    Indikatoren. Der Wert 0 bedeutet keine
                    Verhaltensempfehlungen; 100 entspricht strengen Vorschriften
                    in allen Bereichen. Stand 24. Mai 2020
                  </span>
                </div>
                <AutofitIFrame src='//datawrapper.dwcdn.net/Mie7Z/12' />
              </div>
              <Mdx
                className='ta text'
                file={require('text/qovCcK8KvpX9.mdx')}
              />
            </div>
          </div>
          <div className='ui vertical very fitted segment section'>
            <div className='ui text container'>
              {
                // Epidemiologie
              }
              <Mdx
                className='ta text'
                file={require('text/2cfdUJ_5g3Ae.mdx')}
              />
            </div>
          </div>
          <div className='ui vertical very fitted segment graphic'>
            <div className='ui container'>
              {
                // Epidemiologie Charts
              }
              <div className='ui three column grid doubling stackable'>
                <div className='row'>
                  <div className='column epidemie'>
                    <div className='titleBox wirtschaft'>
                      <h4 className='ui infographic header'>
                        Tägliche bestätigte Neuinfektionen
                      </h4>
                      <span className='cases'>Stand 24. Mai 2020</span>
                    </div>
                    <div className='iframeWrapper'>
                      <div className='iframeBoxWirtschaft'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/V6uAh/8'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='column epidemie'>
                    <div className='titleBox wirtschaft'>
                      <h4 className='ui infographic header'>
                        Gesamtzahl der Infektionen
                      </h4>
                      <span className='cases'>Stand 24. Mai 2020</span>
                    </div>
                    <div className='iframeWrapper'>
                      <div className='iframeBoxWirtschaft'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/vFfp0/7'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='column epidemie'>
                    <div className='titleBox wirtschaft'>
                      <h4 className='ui infographic header'>
                        Gesamtzahl der Todesfälle
                      </h4>
                      <span className='cases'>Stand 24. Mai 2020</span>
                    </div>
                    <div className='iframeWrapper'>
                      <div className='iframeBoxWirtschaft'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/FaLk1/8'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='ui container age'>
              <div className='ui three column grid doubling stackable'>
                <div className='row'>
                  <div className='column special'>
                    <div className='titleBox'>
                      <h4 className='ui infographic header'>
                        Infektionen nach Altersgruppe
                      </h4>
                      <span className='cases'>
                        Fallzahl: 33’449 in Schweden, 30’681 in der Schweiz;
                        Stand 24. Mai 2020
                      </span>
                    </div>
                    <div className='iframeWrapperAlter'>
                      <div className='iframeBoxAlter'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/MwwTR/'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='column special'>
                    <div className='titleBox'>
                      <h4 className='ui infographic header'>
                        Todesfälle nach Altersgruppe
                      </h4>
                      <span className='cases'>
                        Fallzahl: 3998 Tote in Schweden, 1640 Tote in der
                        Schweiz; Stand 24. Mai 2020
                      </span>
                    </div>
                    <div className='iframeWrapperAlter'>
                      <div className='iframeBoxAlter'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/HjC8p/3'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='column special'>
                    <div className='titleBox'>
                      <h4 className='ui infographic header'>
                        Sterblichkeitsrate nach Altersgruppe
                      </h4>
                      <span className='cases'>
                        Lesebeispiel: Rund jeder vierte Covid-19-Patient im
                        Alter von 70-79 Jahren stirbt in Schweden am Virus, in
                        der Schweiz jeder achte. Stand 24. Mai 2020
                      </span>
                    </div>
                    <div className='iframeWrapperAlter'>
                      <div className='iframeBoxAlter'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/frVxE/3'
                          style={{ height: '100%' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {
              // Epidemiologie Altersverteilung
            }
            <Mdx className='ta text' file={require('text/iBatV_U_l8Gm.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment section'>
          <div className='ui text container'>
            {
              // Wirtschaft
            }
            <Mdx className='ta text' file={require('text/e_o-gBlLmuxy.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment graphic'>
          <div className='ui container economy'>
            <div className='ui three column grid doubling stackable'>
              <div className='row'>
                <div className='column wirtschaft'>
                  <div className='titleBox wirtschaft'>
                    <h4 className='ui infographic header'>BIP-Wachstum</h4>
                    <span className='cases'>
                      Jährliche Wachstumsrate des Bruttoinland&shy;produkts in
                      Prozent; Stand Prognose April 2020
                    </span>
                  </div>
                  <div className='iframeWrapper'>
                    <div className='iframeBoxWirtschaft'>
                      <AutofitIFrame
                        src='//datawrapper.dwcdn.net/52i5K/'
                        style={{ height: '100%' }}
                      />
                    </div>
                  </div>
                </div>

                <div className='column wirtschaft'>
                  <div className='titleBox wirtschaft'>
                    <h4 className='ui infographic header'>Arbeitslosenquote</h4>
                    <span className='cases'>
                      Jährliche Arbeitslosenquote in Prozent; Stand Prognose
                      April 2020
                    </span>
                  </div>
                  <div className='iframeWrapper'>
                    <div className='iframeBoxWirtschaft'>
                      <AutofitIFrame
                        src='//datawrapper.dwcdn.net/AiUt2/'
                        style={{ height: '100%' }}
                      />
                    </div>
                  </div>
                </div>

                <div className='column wirtschaft'>
                  <div className='titleBox wirtschaft'>
                    <h4 className='ui infographic header'>Exporte</h4>
                    <span className='cases'>
                      Jährliche Wachstumsrate der Exporte in Prozent; Stand
                      Prognose April 2020
                    </span>
                  </div>
                  <div className='iframeWrapper'>
                    <div className='iframeBoxWirtschaft'>
                      <AutofitIFrame
                        src='//datawrapper.dwcdn.net/KO66V/'
                        style={{ height: '100%' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {
              // Schlussfolgerung
            }
            <Mdx className='ta text' file={require('text/FsadZIm_-ES4.mdx')} />
            <div style={{ margin: '2rem 0' }}>
              <div className='titleBox'>
                <h4 className='ui infographic header'>
                  Entwicklung der Verschuldungsquoten
                </h4>
                <span className='cases'>
                  Staatsverschuldung in Prozent des Bruttoinlandprodukts; Stand Prognose April 2020
                </span>
              </div>
              <AutofitIFrame src='//datawrapper.dwcdn.net/iC8v4' />
            </div>
            <Mdx className='ta text' file={require('text/qsJTh7iEcxLe.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui container'>
            <div className='ui text container chart'>
              In der folgenden interaktiven Grafik können Sie den Verlauf der
              Epidemie in verschiedenen Ländern und mit verschiedenen Skalen
              vergleichen – eine detaillierte Darstellung der neuesten Zahlen
              finden Sie in unserer{' '}
              <Link href='https://interaktiv.tagesanzeiger.ch/2020/covid-19-ausbruch-im-vergleich/?nosome'>
                Übersicht
              </Link>
              .
            </div>
            <AllCountriesChart />
          </div>
        </div>

        {/* TODO Add your credits in this component */}
        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie verständlich waren die Grafiken?'
          ]}
          credits={[
            ['Konzept und Umsetzung', 'Andreas Moor, Patrick Vögeli'],
            [
              'Quellen',
              `
              Massnahmen: <br><a href="https://ncs-tf.ch/de/policy-briefs/comparison-of-sweden-and-switzerland-2" target="_blank">Swiss National COVID-19 Science Task Force</a>, <a href="https://ibz-shiny.ethz.ch/covid-19-re/" target="_blank">ETH Zürich</a>, 
               <a href="https://www.worldometers.info/coronavirus/" target="_blank">Worldometer</a>, 
               <a href="https://www.arcgis.com/apps/opsdashboard/index.html#/bda7594740fd40299423467b48e9ecf6" target="_blank">Johns Hopkins University</a>,
               <a href="https://github.com/OxCGRT/covid-policy-tracker" target="_blank">Oxford COVID-19 Government Response Tracker</a>
               <br>Verlauf der Epidemie: <br>
               <a href="https://experience.arcgis.com/experience/09f821667ce64bf7be6f9f87457ed9aa" target="_blank">Schwedische Gesundheitsbehörde</a>,
               <a href="https://covid-19-schweiz.bagapps.ch/de-1.html" target="_blank">Bundesamt für Gesundheit</a>
              <br>

               Wirtschaftliche Aussichten: <br>
               <a href="https://data.oecd.org/trade/trade-in-goods-and-services.htm#indicator-chart" target="_blank">OECD</a>,
               <a href="https://www.imf.org/external/pubs/ft/weo/2020/01/weodata/index.aspx" target="_blank">IWF</a>,
               <a href="https://www.konj.se/english/publications/swedish-economy-report/swedish-economy/2020-05-04-updated-economic-outlook.html" target="_blank">Konjunkturinstitutet</a>,
               <a href="https://www.seco.admin.ch/seco/de/home/wirtschaftslage---wirtschaftspolitik/Wirtschaftslage/konjunkturprognosen.html" target="_blank">Staatssekretariat für Wirtschaft</a>
               `
            ]
          ]}
        />
      </div>
    </MDXProvider>
  )
}
